export default "__VITE_ASSET__Nob$TnVr__"